module.exports = __webpack_public_path__ + "8404fed51731c88cfa90f0604bca7dd3.pdf";